import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { adminRequest } from '../../utils/adminRequest';

function AdminRegistrations() {
  const [searchParams] = useSearchParams();
  const initActivityId = searchParams.get('activityId') ? parseInt(searchParams.get('activityId'), 10) : null;

  const [activities, setActivities] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activityId, setActivityId] = useState(initActivityId || '');
  const [activityName, setActivityName] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [addForm, setAddForm] = useState({
    activityId: initActivityId || '',
    gender: '',
    phone: '',
    wechat: ''
  });
  const [adding, setAdding] = useState(false);
  const [lastOrderNo, setLastOrderNo] = useState('');

  const fetchActivities = async () => {
    try {
      const res = await adminRequest({ url: '/api/admin/activities', method: 'GET' });
      setActivities(res.data || []);
    } catch {}
  };

  const fetchList = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (activityId) params.set('activityId', activityId);
      if (activityName) params.set('activityName', activityName);
      const res = await adminRequest({ url: `/api/admin/registrations?${params}`, method: 'GET' });
      setList(res.data || []);
    } catch (err) {
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchActivities(); }, []);
  useEffect(() => { fetchList(); }, [activityId, activityName]);

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setAdding(true);
    try {
      const res = await adminRequest({
        url: '/api/admin/registrations',
        method: 'POST',
        data: {
          activityId: addForm.activityId ? parseInt(addForm.activityId, 10) : null,
          gender: addForm.gender,
          phone: addForm.phone,
          wechat: addForm.wechat || undefined
        }
      });
      setLastOrderNo(res.data.orderNo || '');
      fetchList();
      alert(res.data.message || '报名已入库');
    } catch (err) {
      alert(err.response?.data?.error || '添加失败');
    } finally {
      setAdding(false);
    }
  };

  const handleMarkPaid = async () => {
    if (!lastOrderNo) return;
    if (!window.confirm('确定标记该订单为已支付？')) return;
    try {
      await adminRequest({ url: '/api/admin/registrations/mark-paid', method: 'POST', data: { orderNo: lastOrderNo } });
      alert('已标记为已支付');
      setLastOrderNo('');
      setShowAdd(false);
      setAddForm({ activityId: '', gender: '', phone: '', wechat: '' });
      fetchList();
    } catch (err) {
      alert(err.response?.data?.error || '操作失败');
    }
  };

  const formatPrice = (c) => c != null ? `¥${(c / 100).toFixed(2)}` : '-';
  const formatDate = (d) => d ? new Date(d).toLocaleString('zh-CN') : '-';

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <h2>报名管理</h2>
        <button
          onClick={() => setShowAdd(true)}
          style={{ padding: '10px 20px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}
        >
          + 添加报名
        </button>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <select
          value={activityId}
          onChange={(e) => setActivityId(e.target.value ? parseInt(e.target.value, 10) : '')}
          style={{ padding: 10, borderRadius: 6, minWidth: 200 }}
        >
          <option value="">全部活动</option>
          {activities.map((a) => (
            <option key={a.id} value={a.id}>{a.title}</option>
          ))}
        </select>
        <input
          type="text"
          placeholder="活动名称筛选"
          value={activityName}
          onChange={(e) => setActivityName(e.target.value)}
          style={{ padding: 10, borderRadius: 6, minWidth: 180 }}
        />
      </div>

      {loading ? (
        <div>加载中...</div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>活动</th>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>性别</th>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>手机</th>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>微信号</th>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>金额</th>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>状态</th>
                <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #eee' }}>报名时间</th>
              </tr>
            </thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: 12 }}>{r.activity_title}</td>
                  <td style={{ padding: 12 }}>{r.gender === 'male' ? '男' : r.gender === 'female' ? '女' : '-'}</td>
                  <td style={{ padding: 12 }}>{r.phone}</td>
                  <td style={{ padding: 12 }}>{r.wechat || '-'}</td>
                  <td style={{ padding: 12 }}>{formatPrice(r.final_price)}</td>
                  <td style={{ padding: 12 }}>{r.status === 'paid' ? '已支付' : '待支付'}</td>
                  <td style={{ padding: 12 }}>{formatDate(r.paid_at || r.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {list.length === 0 && <p style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无报名记录</p>}
        </div>
      )}

      {showAdd && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000, padding: 20
        }} onClick={() => !adding && setShowAdd(false)}>
          <div style={{
            background: '#fff', borderRadius: 16, padding: 32, maxWidth: 440, width: '100%', maxHeight: '90vh', overflow: 'auto'
          }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>添加报名</h3>
            <form onSubmit={handleAddSubmit}>
              <label style={{ display: 'block', marginBottom: 4 }}>选择活动 *</label>
              <select
                name="activityId"
                value={addForm.activityId}
                onChange={(e) => setAddForm((p) => ({ ...p, activityId: e.target.value }))}
                required
                style={{ width: '100%', padding: 10, marginBottom: 16, boxSizing: 'border-box' }}
              >
                <option value="">请选择</option>
                {activities.filter((a) => a.status === 'published').map((a) => (
                  <option key={a.id} value={a.id}>{a.title}</option>
                ))}
              </select>

              <label style={{ display: 'block', marginBottom: 4 }}>性别 *</label>
              <select
                value={addForm.gender}
                onChange={(e) => setAddForm((p) => ({ ...p, gender: e.target.value }))}
                required
                style={{ width: '100%', padding: 10, marginBottom: 16, boxSizing: 'border-box' }}
              >
                <option value="">请选择</option>
                <option value="male">男</option>
                <option value="female">女</option>
              </select>

              <label style={{ display: 'block', marginBottom: 4 }}>手机号 *</label>
              <input
                type="tel"
                value={addForm.phone}
                onChange={(e) => setAddForm((p) => ({ ...p, phone: e.target.value }))}
                required
                placeholder="用于联系"
                style={{ width: '100%', padding: 10, marginBottom: 16, boxSizing: 'border-box' }}
              />

              <label style={{ display: 'block', marginBottom: 4 }}>微信号</label>
              <input
                type="text"
                value={addForm.wechat}
                onChange={(e) => setAddForm((p) => ({ ...p, wechat: e.target.value }))}
                placeholder="选填"
                style={{ width: '100%', padding: 10, marginBottom: 16, boxSizing: 'border-box' }}
              />

              <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                <button type="submit" disabled={adding} style={{ padding: 12, background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
                  {adding ? '提交中...' : '入库并生成订单'}
                </button>
                <button type="button" onClick={() => setShowAdd(false)} style={{ padding: 12, background: '#eee', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
                  取消
                </button>
              </div>
            </form>

            {lastOrderNo && (
              <div style={{ marginTop: 20, padding: 12, background: '#f0fdf4', borderRadius: 8 }}>
                <p style={{ margin: '0 0 8px' }}>✅ 报名已入库，订单号: {lastOrderNo}</p>
                <p style={{ margin: '0 0 8px', fontSize: 13, color: '#666' }}>若用户已线下支付，点击下方按钮标记</p>
                <button onClick={handleMarkPaid} style={{ padding: 8, background: '#22c55e', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                  线下已付，标记为已支付
                </button>
                <button onClick={() => { setLastOrderNo(''); setShowAdd(false); setAddForm({ activityId: '', gender: '', phone: '', wechat: '' }); }} style={{ marginLeft: 8, padding: 8, background: '#94a3b8', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>
                  完成
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminRegistrations;
